import { NotificationOptions, useNotify } from 'react-admin'

type Options = NotificationOptions

const infoOptions: Options = { type: 'info', multiLine: true }
const errorOptions: Options = { type: 'error', multiLine: true }
const successOptions: Options = { type: 'success', multiLine: true }

const useAlert = () => {
  const notify = useNotify()

  const alertInfo = (message: string) => notify(message, infoOptions)
  const alertSuccess = (message: string) => notify(message, successOptions)
  const alertError = (message: string) => notify(message, errorOptions)

  const alertErrors = (message: string[]) => {
    const errorMessage = message.join('\n')
    notify(errorMessage, errorOptions)
  }

  return {
    alertInfo,
    alertSuccess,
    alertError,
    alertErrors
  }
}

export default useAlert
